import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ENDPOINTS } from "../../../config/api";
import Select from "react-select";

const Certificate = () => {
  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [people, setPeople] = useState([]);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState({});

  /* =========================
     CARGAR PERSONAS CON CONTRATO
  ========================= */
  useEffect(() => {
    const fetchPeople = async () => {
      const data = await authFetch(ENDPOINTS.getCurriculumContract);
      if (data?.success) {
        setPeople(data.people);
      }
    };

    fetchPeople();
  }, [authFetch]);

  /* =========================
     SELECCIONAR PERSONA
  ========================= */
  const handleSelectPerson = useCallback(
    async (selected) => {
      if (!selected) {
        setSelectedPerson(null);
        setContracts([]);
        return;
      }

      const id = selected.value;
      setSelectedPerson(id);
      setLoading(true);

      const data = await authFetch(
        `${ENDPOINTS.getContractByCurriculum}?id_curriculum=${id}`
      );

      if (data?.success) {
        setContracts(data.contracts);
      } else {
        setContracts([]);
      }

      setLoading(false);
    },
    [authFetch]
  );

  /* =========================
     TOGGLE OPCIONES PDF
  ========================= */
  const toggleOption = (id_contrato, option) => {
    setOptions((prev) => ({
      ...prev,
      [id_contrato]: {
        ...prev[id_contrato],
        [option]: !prev[id_contrato]?.[option],
      },
    }));
  };

  /* =========================
     OPTIONS SELECT
  ========================= */
  const peopleOptions = people.map((p) => ({
    value: p.id_curriculum,
    label: `${p.first_name} ${p.last_name} — ${p.document}`,
  }));

  /* =========================
     PDF INDIVIDUAL
  ========================= */
  const handleDownloadCertificate = (id_contrato) => {
    const salario = options[id_contrato]?.salario ? 1 : 0;
    const funciones = options[id_contrato]?.funciones ? 1 : 0;

    const url =
      `${ENDPOINTS.certificatePdf}` +
      `?id_contrato=${id_contrato}` +
      `&salario=${salario}` +
      `&funciones=${funciones}`;

    window.open(url, "_blank");
  };

  /* =========================
     PDF GENERAL
  ========================= */
  const handleDownloadAllCertificates = () => {
    const url = `${ENDPOINTS.certificatePdfAll}?id_curriculum=${selectedPerson}`;
    window.open(url, "_blank");
  };

  return (
    <div className="container mt-4 p-4">
      <div className="d-flex justify-content-between align-items-center my-3">
        <h3>Certificado Laboral</h3>
        <button
          className="btn btn-outline-pink"
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left me-1"></i>Volver
        </button>
      </div>

      {/* ================= BUSCADOR ================= */}
      <div className="card mt-3 shadow-sm">
        <div className="card-body">
          <label className="form-label fw-bold">
            Buscar persona con contrato
          </label>

          <Select
            options={peopleOptions}
            placeholder="Buscar persona por nombre o documento..."
            isClearable
            value={
              peopleOptions.find(
                (opt) => opt.value === selectedPerson
              ) || null
            }
            onChange={handleSelectPerson}
          />
        </div>
      </div>

      {/* ================= RESULTADOS ================= */}
      {loading && <p className="mt-3">Cargando contratos...</p>}

      {!loading && selectedPerson && contracts.length === 0 && (
        <div className="alert alert-warning mt-3">
          Esta persona no tiene contratos registrados
        </div>
      )}

      {!loading && contracts.length > 0 && (
        <>
          <table className="table table-bordered mt-4">
            <thead className="table-light">
              <tr>
                <th>Cargo</th>
                <th>Programa</th>
                <th>Tipo</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Certificado</th>
              </tr>
            </thead>
            <tbody>
              {contracts.map((c) => (
                <tr key={c.id_contrato}>
                  <td>{c.job_position}</td>
                  <td>{c.program_name}</td>
                  <td>{c.type_contract}</td>
                  <td>{c.start_date}</td>
                  <td>{c.end_date || "Vigente"}</td>
                  <td>
                    <div className="mb-2">
                      <input
                        type="checkbox"
                        checked={options[c.id_contrato]?.salario || false}
                        onChange={() =>
                          toggleOption(c.id_contrato, "salario")
                        }
                      />{" "}
                      Salario
                      <br />
                      <input
                        type="checkbox"
                        checked={options[c.id_contrato]?.funciones || false}
                        onChange={() =>
                          toggleOption(c.id_contrato, "funciones")
                        }
                      />{" "}
                      Funciones
                    </div>

                    <button
                      className="btn btn-outline-purple btn-sm w-100"
                      onClick={() =>
                        handleDownloadCertificate(c.id_contrato)
                      }
                    >
                      <i className="bi bi-filetype-pdf me-2"></i>
                      PDF
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <button
            className="btn btn-outline-pink"
            onClick={handleDownloadAllCertificates}
          >
            <i className="bi bi-download me-2"></i>
            Descargar todos los certificados
          </button>
        </>
      )}
    </div>
  );
};

export default Certificate;